// Recovered compiled webpack factory 15860. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "HandleISRError", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let r = void 0;
  function n(e) {
    let { error: t } = e;
    if (r) {
      let e = r.getStore();
      if ((null == e ? void 0 : e.isRevalidate) || (null == e ? void 0 : e.isStaticGeneration))
        throw (console.error(t), t);
    }
    return null;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
